import { render, staticRenderFns } from "./gpsrTemplateEdit.vue?vue&type=template&id=4ec2d506&scoped=true&"
import script from "./gpsrTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./gpsrTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./gpsrTemplateEdit.vue?vue&type=style&index=0&id=4ec2d506&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec2d506",
  null
  
)

export default component.exports